import React from "react";
import { Link } from "react-router-dom";
import { IoMdOpen } from "react-icons/io";
import { MdCheckCircle, MdCancel } from "react-icons/md";
import { TiInfoLarge } from "react-icons/ti";
import { Figure, Button } from "react-bootstrap";
import * as API from "../../../api";
import * as UTILS from "../../../helpers/Utility";
import { Settings } from "../../../helpers/Contexts";
import EditCpr from "./EditCpr";

const CprData = ({ data }) => {
  const settings = React.useContext(Settings);

  return (
    <>
      <div className=" mt10">
        CPR:{" "}
        <b>
          #{data.id}
          {data.in_review ? (
            <MdCheckCircle className="ml5 patient-check" />
          ) : (
            <MdCancel className="ml5 patient-close" />
          )}
          In Review
        </b>
        <br />
        Created:
        <b>
          {" "}
          {new Date(data.created_at).toLocaleString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </b>
        <br />
        Code: <b>{data.cpr_code}</b>
        <br />
        <TiInfoLarge id="cpr-big-icon" />
        Procedure Type: <b>{data.procedure_type}</b>
        <br />
        Ordering Provider:<b> {data.ordering_provider && data.ordering_provider}</b>
        <br />
        Servicing Provider:<b> {data.servicing_provider && data.servicing_provider} </b>
        <br />
        Date Type: <b>{data.date_type}</b>
        <br />
        {data.date_type == "Appointment Date" ? (
          <>
            Appointment Date: <b>{data.appointment_date} </b>
            <br />
            Appointment Time:
            <b>
              {" "}
              {data.appointment_time ? UTILS.ConvertToPacificTime(data.appointment_time) : ""}{" "}
            </b>
            (Pacific Standard/Daylight Time
            )<br />
          </>
        ) : (
          <>
            Due Date: <b>{data.due_date}</b> <br />
          </>
        )}
        {data.completed_on_date && (
          <>
            Completed on date: <b>{data.completed_on_date}</b> <br />
          </>
        )}
        {data.attending_provider && (
          <>
            Attending provider: <b>{data.attending_provider}</b>
            <br />
          </>
        )}
        <div>
          {settings.me.support_agent_type == "Admin" ? (
            <EditCpr data={data} />
          ) : (
            <>
              Status: <b>{data.status} </b>
              <br />
              Substatus:
              <b>
                <i> {data.sub_status}</i>
              </b>
              <br />
              Patient Response Status:
              {data.cpr_type_response_status && <b>{data.cpr_type_response_status}</b>}
              <br />
              Order Not Available Reason:
              <b>{ data.order_not_available_reason }</b>
              {!data.document.url && !data.order_document.url ? null : (
                <>
                  {(data.document.url || data.order_document.url) && (
                    <div className="mt10">
                      <label>Documents </label>
                      {data.order_document.url ? (
                        <Figure className="document">
                          <Link
                            to={{ pathname: data.order_document.url }}
                            target="_blank"
                            className="no-style"
                            rel="noopener noreferrer"
                          >
                            <b>
                              Order <IoMdOpen />
                            </b>
                            <br />
                            {UTILS.FileNameFromUrl(data.order_document.url)}
                          </Link>
                        </Figure>
                      ) : (
                        <Figure className="document-empty">
                          <b>No Order Attached</b>
                        </Figure>
                      )}
                      {data.document.url ? (
                        <Figure className="document">
                          <Link
                            to={{ pathname: data.document.url }}
                            target="_blank"
                            className="no-style"
                            rel="noopener noreferrer"
                          >
                            <b>
                              Order <IoMdOpen />
                            </b>
                            <br />
                            {UTILS.FileNameFromUrl(data.document.url)}
                          </Link>
                        </Figure>
                      ) : (
                        <Figure className="document-empty">
                          <b>No Results Attached</b>
                        </Figure>
                      )}
                    </div>
                  )}
                </>
              )}
              <br />
              { data.verified_in_claims == true && (<>
                  <i className='fa green-text fa-check-circle'></i>
                  <b>Verified in Claims</b>
                </>)
              }
            </>
          )}
          <br />
          { data.patient_textable &&
              (<>
                <Button
                  id="btn outline"
                  onClick={async () => {
                    let response = await API.sendAppointmentInstructionsText(data.id, 'new');
                    if (response) {
                      alert('Sent!');
                    }
                  }}
                >
                  Send Appt Instructions (New Pt)
                </Button>
                <Button
                  id="btn outline"
                  onClick={async () => {
                    let response = await API.sendAppointmentInstructionsText(data.id, 'established');
                    if (response) {
                      alert('Sent!');
                    }
                  }}
                >
                  Send Appt Instructions (Established Pt)
                </Button>

              </>)
          }
          { data.task?.appointment_request_status === 'appointment_not_completed' && (
            <Button
              style={{ backgroundColor: '#d9534f', borderColor: '#d43f3a', color: '#fff', marginTop: '10px', width: '100%' }}
              onClick={async () => {
                if (!window.confirm('Revert this task back to Visit Status Check?')) return;
                const response = await API.updateTask(data.task.id, { task: { appointment_request_status: 'visit_status_check' } });
                if (response && response.ok) {
                  window.location.reload();
                } else {
                  alert('Something went wrong. Please try again.');
                }
              }}
            >
              Revert To Visit Status Check
            </Button>
          )}
        </div>
        {!!data.extensions.length && (
          <>
            <label>
              CPR Extensions <span id="from">Dates extensions were given </span>
            </label>
            {data.extensions.map(
              (i) =>
                i.patient_event_type == "extension" && (
                  <b key={i.patient_event_type + i.created_at}>
                    <span className={"badge rounded-pill closed"}>
                      {new Date(i.created_at).toLocaleDateString()}
                    </span>
                  </b>
                )
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CprData;
